var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.636,
    height: 35,
    viewBox: "0 0 29.636 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M14.489,35a3.769,3.769,0,0,1-1.806-1.043c-2.141-1.931-4.331-3.809-6.286-5.936A26.3,26.3,0,0,1,1.411,20.8,14.149,14.149,0,0,1,3.557,5.23a13.78,13.78,0,0,1,9.1-5.07A14.4,14.4,0,0,1,25.977,5.071a14.388,14.388,0,0,1,2.3,15.7A27.338,27.338,0,0,1,23.288,28,84.946,84.946,0,0,1,16.554,34.3a6.13,6.13,0,0,1-1.382.7ZM12.353,2.3A12.083,12.083,0,0,0,6.815,4.89a12.64,12.64,0,0,0-3.839,5.226,12.086,12.086,0,0,0-.884,4.19,11.825,11.825,0,0,0,.736,4.549,22.29,22.29,0,0,0,4.286,6.891,78.451,78.451,0,0,0,7.3,7,.516.516,0,0,0,.839,0c1.847-1.693,3.733-3.348,5.521-5.1a25.78,25.78,0,0,0,5.542-7.524A12.42,12.42,0,0,0,23.828,5.787a12.292,12.292,0,0,0-8.85-3.734A14.812,14.812,0,0,0,12.353,2.3Zm2.473,18.471a6.513,6.513,0,1,1,.011,0Zm-.011-11a4.469,4.469,0,1,0,.014,0Z",
    transform: "translate(0 0)",
    fill: "#5dadae"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.4a24ee4f6db769e5b5cc0080d473a9bf.svg";
export { ForwardRef as ReactComponent };